export default __webpack_public_path__ + "static/marriott-6902739270bbb8f598340bae7ff2bf08.png";